import { createContext } from 'react';
import { UserEnquiryContext } from 'models/UserEnquiryContext';
import { LoadingStates } from 'hooks/useLoadingState';

type CurrentUserEnquiryContextContextProps = Omit<
  LoadingStates,
  'updateIsLoading'
> & {
  userEnquiryContext: UserEnquiryContext[];
  onNewEnquiryContext: (newEnquiryContext: UserEnquiryContext) => void;
  onUpdateEnquiryContext: (updatedEnquiryContext: UserEnquiryContext) => void;
  onDeleteEnquiryContext: (enquiryContextId: string) => void;
};

export default createContext<Partial<CurrentUserEnquiryContextContextProps>>({
  userEnquiryContext: [],
});
